import React from 'react';

import './Divider.scss';

export default function Divider(): JSX.Element {
  return <div className="Divider" />;
}
